import { PostClosingService } from './postClosingService';

export const postClosingService = new PostClosingService();